module.exports = __webpack_public_path__ + "static/media/arrow-blue.f4392f2b.svg";